import './AuthForm.scss'

import { DarkLogo } from "../../../common-components/Logo/Logo";
import { LargeTitle } from "../../../common-components/Titles/Titles";
import { Field } from "../../../common-components/Field/Field";
import { Button } from "../../../common-components/Buttons/Buttons";
import { CommonTitle } from "../../../common-components/Titles/Titles";

const AuthForm = ({formId, handleLogin, loadingStatus}) => {

    return (
        <div className={"auth-form"}>
            <div className={"auth-form_container"}>
                <div className={"auth-form_content"}>
                    <div className={"auth-form_logo"}>
                        <DarkLogo width={"150"} height={"100"}/>
                    </div>
                    <div className={"auth-form_title"}>
                        <LargeTitle property={"Авторизация"}/>
                    </div>
                    <div className={"auth-form_fields"}>
                        <Field
                            label={"Почта"}
                            type={"email"}
                            name={"email"}
                            formId={formId}
                            validationRules={{required: true}}
                        />
                        <Field
                            label={"Пароль"}
                            type={"password"}
                            name={"password"}
                            formId={formId}
                            validationRules={{required: true}}
                        />
                    </div>
                    <div className={"auth-form_button"}>
                        <Button
                            title={"Войти"}
                            onClick={handleLogin}
                            loadingStatus={loadingStatus}
                        />
                    </div>
                </div>
                <div className={"auth-form_licence"}>
                    <CommonTitle
                        property={"ResQCore® является зарегистрированным товарным знаком на территории Республики Казахстан."}/>
                </div>
            </div>
        </div>
    )
}

export default AuthForm;